
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27.71","height":"27.71"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.631 20.384v-5.409c0-2.9-1.547-4.247-3.61-4.247a3.112 3.112 0 00-2.821 1.559V10.95h-3.141c.042.885 0 9.434 0 9.434H15.2v-5.269a2.138 2.138 0 01.1-.764 1.715 1.715 0 011.607-1.151c1.135 0 1.589.865 1.589 2.133v5.047h3.135zM8.756 9.662a1.635 1.635 0 10.021-3.26 1.635 1.635 0 10-.041 3.26zm5.1 18.047A13.855 13.855 0 1127.71 13.855 13.855 13.855 0 0113.855 27.71zm-3.531-7.326V10.95H7.188v9.434z","fill":"#fff"}})])
          )
        }
      }
    